{
	"dashboard": "Dashboard",
	"recoveryContainer": {
		"footerText": "© 2026 Zig The Global Funtech. Todos los derechos reservados."
	},
	"newLogin": {
		"heroTitle": {
			"prefix": "Zig organiza",
			"suffix": "el ritmo de tu",
			"words": ["show", "consumo", "evento", "festival", "pub"]
		},
		"labels": {
			"company": "Organización",
			"login": "Usuario",
			"password": "Contraseña"
		},
		"description": "Para acceder, complete los datos",
		"fields": {
			"organization": {
				"placeholder": "Ingrese el nombre de la organización",
				"required": "El nombre de la organización es requerido"
			},
			"username": {
				"placeholder": "Ingrese su usuario",
				"required": "Su usuario es requerido"
			},
			"password": {
				"placeholder": "Ingrese su contraseña",
				"required": "Su contraseña es requerida"
			}
		},
		"submit": "Iniciar sesión",
		"forgotPassword": {
			"question": "¿Olvidó su contraseña?",
			"action": "Haga clic aquí"
		}
	}
}
